import { Typography } from '@mui/material'
import { memo, useContext } from 'react'
import tw from 'twin.macro'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import EmptySearchImage from 'src/assets/images/empty-search.svg'
import { colors } from 'src/theme'
import { LinkSubcontractorContext } from '../LinkSubcontractor.context'
import { LinkSubcontractorTableContext } from './LinkSubcontractorTable.context'

const EmptyLinkedContractorsComponent = () => {
  const { searchQuery } = useContext(LinkSubcontractorContext)
  const { statusFilter } = useContext(LinkSubcontractorTableContext)

  const isSearchUsed = Boolean(searchQuery || statusFilter.length)

  return (
    <div css={tw`flex flex-1 h-full justify-center items-center flex-col`}>
      <img src={isSearchUsed ? EmptySearchImage : EmptyImage} />
      <Typography css={tw`mb-1 mt-2 w-[270px] text-center`} variant="h4" fontWeight={600}>
        {isSearchUsed ? 'No assigned contractors found' : 'No contractors assigned yet'}
      </Typography>
      <Typography css={tw`w-[270px] text-center`} color={colors.SHADES_GREY_400} variant="body2">
        {isSearchUsed
          ? 'Please try a different search query or filters.'
          : 'This board is currently empty. Use the "Assign Contractors" button to allocate workers to this customer.'}
      </Typography>
    </div>
  )
}

export const EmptyLinkedContractors = memo(EmptyLinkedContractorsComponent)
